module.exports = __webpack_public_path__ + "assets/e94f5e3ed7a8f4412388938fa51c4543.png";